export class SearchParameters<T> {
  query: T;
  pageIndex: number = 0;
  pageSize: number = 10;
  userEmail: string;
}